import {
    Avatar,
    Message,
    MessageList,
    MessageSeparator,
} from '@chatscope/chat-ui-kit-react';
import { Box, Flex, Group } from '@mantine/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TestMessage from './TestMessage';
import dayjs from 'dayjs';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';

/**
 * @param {Array<{userId: string, at: string|Date, [key: string]: any}>} messages
 * @returns {Array<Array<Object>>}
 */
function sortAndGroupMessages(messages) {
    // 1) Clone & sort by timestamp ascending
    const sorted = [...messages].sort(
        (a, b) => new Date(a.at).getTime() - new Date(b.at).getTime()
    );

    // 2) Iterate and group consecutive messages by userId
    const groups = [];
    for (const msg of sorted) {
        const lastGroup = groups[groups.length - 1];
        if (!lastGroup || lastGroup[0].userId !== msg.userId) {
            // new group for a different user
            groups.push([msg]);
        } else {
            // same user as previous message → append to current group
            lastGroup.push(msg);
        }
    }
    return groups;
}

const ChatMessageList = ({
    messages,
    userTyping = false,
    botTyping = false,
}) => {
    const groupedMessages = sortAndGroupMessages(messages);

    const firstMessage = groupedMessages[0]?.[0];

    const getClassName = (message) => {
        const lookup = {
            ProhibitedKeyword: 'message-prohibited',
            OptOut: 'message-opt-out',
        };
        return lookup[message.subType] || null;
    };

    return (
        <Box
            p={'sm'}
            h={'100%'}>
            <MessageSeparator content={dayjs(firstMessage.at).format('LLLL')} />
            {groupedMessages.map((array) => (
                <>
                    {array.map((x, i) => (
                        <TestMessage
                            className={getClassName(x)}
                            model={{
                                direction:
                                    x.direction === 'In'
                                        ? 'incoming'
                                        : 'outgoing',
                                message: x.content,
                                sentTime: 'just now',
                                sender: 'Joe',
                                position:
                                    i === array.length - 1
                                        ? 'single'
                                        : 'normal',
                            }}
                            avatarSpacer={
                                i === array.length - 1 ? false : true
                            }>
                            {x.type == 'Mms' ? (
                                <Message.ImageContent
                                    src={x.content}></Message.ImageContent>
                            ) : null}
                            {i === array.length - 1 ? (
                                <Avatar
                                    src={
                                        'https://i.pravatar.cc/100?u=' +
                                        x.conversationId +
                                        (x.direction === 'In' ? 0 : 1)
                                    }
                                />
                            ) : null}
                        </TestMessage>
                    ))}
                </>
            ))}
        </Box>
    );
};
export default ChatMessageList;
